import { Component, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { ColDef, Column, IHeaderParams } from 'ag-grid-community';
import { IoniconsOutline } from '@pt/pt-models';
import { IonicModule } from '@ionic/angular';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

@Component({
  selector: 'pt-custom-header-tooltip',
  template: `
    <div class="custom-header">
      <div class="custom-header-content" (click)="onSortRequested($event)">
        <span class="header-title">{{ headerName }}</span>

        <ion-icon
          *ngIf="headerTooltip?.length > 0"
          ngbTooltip="{{ headerTooltip }}"
          placement="bottom"
          container="body"
          style="font-size: 16px; color: #288dcc;"
          [name]="IconInfoCircle"
          class="ion-icon"
        ></ion-icon>

        <span class="sort-icon" *ngIf="sortable">
      <ng-container [ngSwitch]="sortDirection">
        <span *ngSwitchCase="'asc'">
          <span class="ag-icon ag-icon-asc"></span>
        </span>
        <span *ngSwitchCase="'desc'">
          <span class="ag-icon ag-icon-desc"></span>
        </span>
      </ng-container>
    </span>
      </div>

      <div class="custom-header-icons">
    <span
      class="ag-header-icon ag-header-cell-menu-button ag-icon ag-icon-menu"
      role="presentation"
      (click)="onMenuClicked($event)"
    ></span>

        <span
          class="ag-header-icon ag-header-cell-filter-button ag-icon ag-icon-filter"
          role="presentation"
          (click)="onMenuClicked($event)"
        ></span>
      </div>
    </div>


  `,
  standalone: true,
  imports: [
    IonicModule,
    NgbTooltip,
    NgIf,
    NgSwitch,
    NgSwitchDefault,
    NgSwitchCase
  ],
  styleUrls: ['./custom-header-tooltip.component.scss']
})
export class CustomHeaderTooltipComponent implements IHeaderAngularComp, OnDestroy {
  public params!: IHeaderParams;
  public headerName!: string;
  public headerTooltip?: string;
  public sortDirection: 'asc' | 'desc' | null = null;
  public sortable: boolean = true;
  private sortChangedListener = this.setSortIcon.bind(this);

  IconInfoCircle = IoniconsOutline.infoCircle;

  agInit(params: IHeaderParams): void {
    this.params = params;
    const colDef: ColDef | undefined | null = (params.column as Column)?.getColDef();

    if (colDef) {
      this.headerName = colDef.headerName || '';
      this.headerTooltip = colDef.headerComponentParams?.tooltip;
      this.sortable = colDef.sortable || false;
    } else {
      this.sortable = false;
    }

    this.setSortIcon();

    if (this.sortable) {
      this.params.column.addEventListener('sortChanged', this.sortChangedListener);
    }
  }

  /** 🔥 Apre il menu AG Grid (menu colonna e filtri) */
  onMenuClicked(event: MouseEvent): void {
    event.stopPropagation();
    if (this.params.showColumnMenu) {
      this.params.showColumnMenu(event.currentTarget as HTMLElement);
    }
  }

  /** 🔥 Cambia l'ordinamento */
  onSortRequested(event: MouseEvent): void {
    event.stopPropagation();
    this.params.progressSort();
  }

  /** 🔥 Aggiorna l'icona di sorting */
  setSortIcon(): void {
    if (this.params.column.isSortAscending()) {
      this.sortDirection = 'asc';
    } else if (this.params.column.isSortDescending()) {
      this.sortDirection = 'desc';
    } else {
      this.sortDirection = null;
    }
  }

  refresh(): boolean {
    this.setSortIcon();
    return true;
  }

  ngOnDestroy(): void {
    if (this.sortable) {
      this.params.column.removeEventListener('sortChanged', this.sortChangedListener);
    }
  }
}
